// extracted by mini-css-extract-plugin
export var actions = "Footer-module--actions--2be1e";
export var certifications = "Footer-module--certifications--c5bfb";
export var copyright = "Footer-module--copyright--18d1d";
export var footer = "Footer-module--footer--be4fa";
export var groupLogo = "Footer-module--group-logo--7b5c8";
export var isoLogo = "Footer-module--iso-logo--cf545";
export var layout = "Footer-module--layout--f12aa";
export var light = "Footer-module--light--029d8";
export var link = "Footer-module--link--16d33";
export var list = "Footer-module--list--41e5f";
export var logo = "Footer-module--logo--3bcfd";
export var marketing = "Footer-module--marketing--9caa3";
export var metadata = "Footer-module--metadata--19986";
export var navigationRow = "Footer-module--navigation-row--392ce";
export var navigations = "Footer-module--navigations--350d6";
export var platform = "Footer-module--platform--5e0a7";
export var small = "Footer-module--small--7075a";
export var social = "Footer-module--social--c41a9";
export var socialIcon = "Footer-module--social-icon--79a57";